module.exports = __webpack_public_path__ + "static/media/visa.e0102565.svg";